<template>
  <div class="core-scroll-up-button">
    <v-btn
      color="bg-gray-0"
      width="40"
      height="40"
      fab
      data-qa="core-scroll-up-button"
      aria-label="Наверх"
      @click="scrollToTop"
    >
      <v-icon color="icon-secondary">
        ui-icon-arrow-up
      </v-icon>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
/**
 * Кнопка прокрутки страницы наверх.
 *
 * По клику вызывает Vuetify `goTo(0)`. Нужна на длинных страницах
 * (отзывы, мемориал), где пользователь уходит далеко вниз.
 */
import goTo from 'vuetify/lib/services/goto'

function scrollToTop() {
  goTo(0)
}
</script>
